<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Siųsto pranešimo registracijos Nr."
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siųsto pranešimo registracijos nr"
                  v-model="mainData['journal_no-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.msgSendTypes"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Siuntimo būdas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siuntimo būdas"
                  v-model="mainData['send_mode-search-simple']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Identifikavimo kodas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Identifikavimo kodas"
                  v-model="mainData['code-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Adresato asmens kodas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Adresato asmens kodas"
                  v-model="mainData['addressee_code-search-like']"
                  hide-details
                  :maxlength="11"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="El. pašto adresas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. El pašto adresas"
                  v-model="mainData['addressee_email-search-like']"
                  hide-details
                  :maxlength="200"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Telefono Nr."
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Telefono nr"
                  v-model="mainData['addressee_phone-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Adresatas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Adresatas"
                  v-model="mainData['addressee_fullname-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.outJournalType"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Registro pranešimas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Registro pranešimas"
                  v-model="mainData['out_journal_type-search-simple']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.msgStatusTypes"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Būsena"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Būsena"
                  v-model="mainData['status-search-custom']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :beforeDates="mainData['sent_at-search-custom']"
                  label="Siuntimo data nuo"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siuntimo data nuo"
                  v-model="mainData['sent_at-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :afterDates="mainData['sent_at-search-from']"
                  label="Siuntimo data iki"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siuntimo data iki"
                  v-model="mainData['sent_at-search-custom']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn object="out-journals" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminJournalNotificationSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
